export default __webpack_public_path__ + "static/media/capital-empregado-risco.d04d77df.svg";